/* eslint-disable */
import React, { Component } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import cookie from "react-cookies";
import { apiUrl, unquieID } from "../Settings/Config";
import reloadQr from "../../common/images/reload_qr.png";
import { showAlert, showPriceValue, showLoaderLst, hideLoaderLst } from "../Helpers/SettingHelper";
import Swal from "sweetalert2";
var qs = require("qs");
var downloadTimer = "";
class RedeemForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_page: "Redeem Credits",
      user_credits: "",
      user_credits_error: "",

      qrcode_str: "",
      runingNum: 0,
      qrCode: "",
      inititalLoad: true,
      showRedeemCredits:false,
      allowToApprove:false,
      qrDetails:[]
    };

    if (
      cookie.load("LoginUserId") === undefined ||
      cookie.load("LoginUserId") === ""
    ) {
      props.history.push("/");
    }
  }
  componentDidMount() {
    this.checkCredits()
  }

  checkCredits() {
    var urlShringTxt = apiUrl + "merchant/getSettings";
    axios.get(urlShringTxt, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ showRedeemCredits: (res.data.result.companyRedeemType==="1")?true:false }, ()=> {
          if(this.state.showRedeemCredits===false) {
            this.generateCustQrcode()
          }
        });
      }
    }).catch((e) => {console.error("Error fetching data:", e);})
  }

  handleFldChange(event) {
    const re = /^[0-9 \b]+$/;
    //if(event.target.value === "") {
    var mblnumber = this.space(event.target.value);
    var mblnumberLenght = mblnumber.length;
    this.setState({ user_credits: mblnumber });
    //}
    this.setState({ user_credits_error: "" });
  }

  handleFldChange_old(event) {
    const re = /^[0-9 \b]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      var mblnumber = this.space(event.target.value);
      var mblnumberLenght = mblnumber.length;
      if (mblnumberLenght <= 9) {
        this.setState({ user_credits: mblnumber });
      }
    }
    this.setState({ user_credits_error: "" });
  }

  space(el) {
    var numbes = el.replace(/ /g, "");
    return numbes.replace(/(\d{4})/g, "$1 ").replace(/(^\s+|\s+$)/, "");
  }

  gotoRedeemFun(event) {
    event.preventDefault();
    let userCredits = this.state.user_credits;
    if (parseFloat(userCredits) > 0) {
      this.generateCustQrcode();
      /*  localStorage.setItem("usercredits", userCredits);
      this.props.history.push("/scanqrcode"); */
    } else {
      this.setState({ user_credits_error: "Please Enter Credits" });
    }
  }

  generateCustQrcode() {
    clearInterval(downloadTimer);
    var postObject = {};
    postObject = {
      QRType: "Redeem Cash Voucher",
      redeemAmount: (this.state.showRedeemCredits===false)?this.state.user_credits:0,
      transactionMode:'QR Payment'
    };
    axios
      .post(
        apiUrl + "merchantQR/generateMerchantQR",
        postObject,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState(
            {
              qrcode_str: res.data.QRImage,
              qrCode: res.data.QRCode,
              runingNum: 120,
            },
            function () {
              this.setRuningNum();
              if (this.state.inititalLoad === true) {
                this.setState({ inititalLoad: false }, function () {
                  this.checkingQRstatus();
                });
              }
            }.bind(this)
          );
        } else {
          showAlert("Error", res.data.message, "error");
        }
      }).catch((e) => {
        const errorMsg = e?.response?.data?.message ?? e?.message;
        showAlert("Error", errorMsg, "error");
      });
  }

  checkingQRstatus() {
    const postObject = {
      qrCode: this.state.qrCode,
    };
    axios
      .post(apiUrl + "merchantQR/checkRedeemCashQrcode", postObject, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        var currentThis = this;
        if (res.data.status === "ok") {
          if (this.state.runingNum > 0) {
            setTimeout(function () {
              currentThis.checkingQRstatus();
            }, 3000);
          }
        } else if (res.data.status === "used") {
          if(this.state.showRedeemCredits===false){
            console.log(res.data, 'res.datares.datares.data')
            this.setState({ qrDetails:res.data.result, allowToApprove:true, runingNum:0 }, ()=> {
              clearInterval(downloadTimer);
            })

            /* Swal.fire({
              title: "Success",
              html: res.data.message,
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            }); */
          //  this.props.history.push("/transactions");
          }else {
           // qrDetails
          }
          
        } else {
        }
      });
  }


  comfirmRedeemFun(event) {
    event.preventDefault();
    let qrDetails = this.state.qrDetails;
    let userCredits = qrDetails.billAmount;
    console.log(qrDetails, 'qrDetails')
    if (qrDetails!==""  && parseFloat(userCredits) > 0) {      
      var postObject = {
        uniqueID: localStorage.getItem('company_app_id'),
        customerID: qrDetails.customerID,
        billPayAmount: qrDetails.billAmount,
        voucherBillAmount: qrDetails.billAmount,
        outletID:qrDetails.outletID,
        qrcode: qrDetails.QRCode,
        paymentMethod: '',
        checkoutType: "redeem",
        approveBy:'merchant'
      };

      showLoaderLst("redeem-btn-cls", "class");
      axios
        .post(apiUrl + "payment/billPay", postObject, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        .then((res) => {
          hideLoaderLst("redeem-btn-cls", "class");
          if (res.data.status === "ok") {
            Swal.fire({
              icon: "success",
              title: "Redeemed!",
              text: "Cash Voucher has been redeemed succuessfully.",
              customClass: {
                confirmButton: "btn btn-success waves-effect",
              },
            });
            this.props.history.push("/transactions");
          } else {
            this.setState({ redeemqr_error: res.data.message });
          }
        }).catch((e) => {
          hideLoaderLst("redeem-btn-cls", "class");
          var errorMsg = e?.response?.data?.message || e.message;
          Swal.fire({
            title: "Error",
            html: errorMsg,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary waves-effect waves-light",
            },
            buttonsStyling: false,
          });
          this.props.history.push("/menu");
          console.error("Error fetching data:", e);
        });
    } else {
      this.setState({ redeemqr_error: "Invalide QR" });
    }
  }
  goBackTo() {
    this.props.history.push('/menu')
  }

  setRuningNum() {
    var rct_this = this;
    var runingNum = this.state.runingNum;
    downloadTimer = setInterval(function () {
      if (runingNum <= 0) {
        clearInterval(downloadTimer);
      }
      runingNum = runingNum - 1;
      rct_this.setState({ runingNum: runingNum }, function () {
        if (runingNum <= 0) {
          rct_this.props.history.push("/menu");
        }
      });
    }, 1000);
  }
  reloadQrFun(event) {
    event.preventDefault();
    var customerId = this.state.UserId;
    this.generateCustQrcode();
  }

  render() {
    let runingNum = this.state.runingNum;
    let qrcode_str = this.state.qrcode_str;
    let qrDetails = this.state.qrDetails;
    console.log(qrDetails, 'qrDetailsqrDetailsqrDetails')
    return (
      <div className="main-div">
        <Header mainpagestate={this.state} prntPagePrps={this.props} />

        <div className="rel">
          <div className="container textcenter">
            <div className="callout">
              {this.state.allowToApprove===true?(

<div className="redeem-profie">
<div className="redeem-profie-box">
  <figure></figure>
  <figcaption>
    <h2>{qrDetails.customerName}</h2>
    <span>{qrDetails.customerPhone}</span>
  </figcaption>
</div>

<>
  <div className="redeem-profie-points textcenter">
    <p>
      Redeem Credits
    </p>
    <strong className="textcls">
      {showPriceValue(
        qrDetails.billAmount)}
    </strong>
  </div>

</>

<div className="redeem-profie-btn textcenter">
  <a
    href={void 0}
    className="button ghost-btn"
    onClick={this.goBackTo.bind(this)}
  >
    Cancel
  </a>
  <a
    href={void 0}
    className="button redeem-btn-cls"
    onClick={this.comfirmRedeemFun.bind(this)}
  >
    Confirm
  </a>
</div>
</div>

              ):(
              
              qrcode_str !== "" && (
                <div className="mbtm-need-less rel">
                  <div className="voucher-redeem-detail textcenter">
                    <div className="vod-header">
                      <h2>Redeem Now</h2>
                      <p>Please show this QR code to customer</p>
                    </div>
                    <div className="vod-body">
                      {runingNum > 0 ? (
                        <img src={qrcode_str} />
                      ) : (
                        <img
                          src={reloadQr}
                          onClick={this.reloadQrFun.bind(this)}
                        />
                      )}
                    </div>
                    {runingNum > 0 && (
                      <div className="vod-footer">
                        <span>QR Code expire in</span>
                        <h2>{this.state.runingNum}</h2>
                        <p>Seconds</p>
                      </div>
                    )}
                    <br></br>
                  </div>
                </div>
              ))}
  {this.state.showRedeemCredits===true && (
    <>
              <p>
                Please enter credit amount
                <br /> to redeem here
              </p>
              <input
                type="input"
                inputMode="decimal"
                pattern="[0-9]*"
                placeholder="Enter credit amount here"
                value={this.state.user_credits}
                onChange={this.handleFldChange.bind(this)}
              />
              {this.state.user_credits_error != "" && (
                <p className="error_info">{this.state.user_credits_error}</p>
              )}
              <a
                href="#"
                className="button"
                onClick={this.gotoRedeemFun.bind(this)}
              >
                Continue to scan QR
              </a>
              </>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RedeemForm;
